

































































import Vue from 'vue';
import checkout from '@/store/modules/checkout';
import Component from 'vue-class-component';
import giftcard from '@/store/modules/giftcard';
import loyalty from '@/store/modules/loyalty';

@Component({
    components: {},
})
export default class Coupon extends Vue {
    private loading: boolean = false;

    private get applied(): boolean {
        return checkout.coupon.applied;
    }

    private get coupon(): string {
        return checkout.coupon.coupon;
    }

    private set coupon(val: string) {
        checkout.setCouponCode(val);
    }

    private get giftCardApplied(): boolean {
        return giftcard.applied;
    }

    private async applyCoupon(couponCode: string) {
        checkout.coupon.error = '';
        const valid = await this.$validator.validate('couponcode');

        if (!valid) {
            return;
        }

        this.loading = true;
        await checkout.applyCoupon(couponCode);
        await loyalty.reloadLoyaltyBenefits(loyalty.isSubscribed);
        this.loading = false;
    }

    private async removeCoupon() {
        this.loading = true;
        await checkout.removeCoupon();
        this.loading = false;
    }
}
